export default __webpack_public_path__ + "static/media/TARA EYES.655e6614.png";